import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "form-group row" };
const _hoisted_2 = {
    class: "col-sm-3 col-form-label",
    for: "inputName"
};
const _hoisted_3 = { class: "col-sm-9" };
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = {
    key: 0,
    class: "form-group__message"
};
const _hoisted_6 = { class: "form-group row" };
const _hoisted_7 = {
    class: "col-sm-3 col-form-label",
    for: "inputContactName"
};
const _hoisted_8 = { class: "col-sm-9" };
const _hoisted_9 = ["placeholder"];
const _hoisted_10 = { class: "form-group row" };
const _hoisted_11 = {
    class: "col-sm-3 col-form-label",
    for: "inputContactEmail"
};
const _hoisted_12 = { class: "col-sm-9" };
const _hoisted_13 = ["placeholder"];
const _hoisted_14 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_15 = { class: "form-group row" };
const _hoisted_16 = {
    class: "col-sm-3 col-form-label",
    for: "inputCountry"
};
const _hoisted_17 = { class: "col-sm-9" };
const _hoisted_18 = ["placeholder"];
const _hoisted_19 = { class: "form-group row" };
const _hoisted_20 = {
    class: "col-sm-3 col-form-label",
    for: "inputRegion"
};
const _hoisted_21 = { class: "col-sm-9" };
const _hoisted_22 = ["placeholder"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('JTADM_NAME')), 1),
            _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    id: "inputName",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.tenant.name) = $event)),
                    type: "text",
                    placeholder: _ctx.$t('JTADM_NAME'),
                    onInput: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => ($setup.v$.tenant.name.$touch && $setup.v$.tenant.name.$touch(...args))),
                    onBlur: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => ($setup.v$.tenant.name.$touch && $setup.v$.tenant.name.$touch(...args)))
                }, null, 40, _hoisted_4), [
                    [_vModelText, $setup.tenant.name]
                ]),
                ((Object.keys($setup.tenant).includes('name') || $setup.v$.tenant.name.$dirty) && $setup.v$.tenant.name.$invalid)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('JTADM_VALIDATION_REQUIRED_NAME')), 1))
                    : _createCommentVNode("", true)
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('JTADM_TENANT_CONTACT_NAME')), 1),
            _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    id: "inputContactName",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.tenant.contact_name) = $event)),
                    type: "text",
                    placeholder: _ctx.$t('JTADM_TENANT_CONTACT_NAME')
                }, null, 8, _hoisted_9), [
                    [_vModelText, $setup.tenant.contact_name]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('JTADM_TENANT_CONTACT_EMAIL')), 1),
            _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    id: "inputContactEmail",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($setup.tenant.contact_email) = $event)),
                    type: "text",
                    placeholder: _ctx.$t('JTADM_TENANT_CONTACT_EMAIL')
                }, null, 8, _hoisted_13), [
                    [_vModelText, $setup.tenant.contact_email]
                ]),
                ($setup.v$.tenant.contact_email.$invalid)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('JTADM_INVALID_EMAIL_ADDRESS')), 1))
                    : _createCommentVNode("", true)
            ])
        ]),
        _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('JTADM_TENANT_COUNTRY')), 1),
            _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    id: "inputCountry",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($setup.tenant.country) = $event)),
                    type: "text",
                    placeholder: _ctx.$t('JTADM_TENANT_COUNTRY')
                }, null, 8, _hoisted_18), [
                    [_vModelText, $setup.tenant.country]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('JTADM_TENANT_REGION')), 1),
            _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    id: "inputRegion",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (($setup.tenant.region) = $event)),
                    type: "text",
                    placeholder: _ctx.$t('JTADM_TENANT_REGION')
                }, null, 8, _hoisted_22), [
                    [_vModelText, $setup.tenant.region]
                ])
            ])
        ])
    ]));
}
